import { useState } from 'react';

interface Testimonial { name: string; quote: string; avatar: string; }
interface TestimonialsProps { testimonials: Testimonial[]; }

export default function Testimonials({ testimonials }: TestimonialsProps) {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];
  const goNext = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const goPrev = () => setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-center">
          <div className="w-full lg:w-2/5">
            <div className="relative rounded-2xl overflow-hidden bg-accent-100" style={{ aspectRatio: '4/5' as string }}>
              <img src={t.avatar} alt={`网友 ${t.name}`} title={`51黑料吃瓜网 - 网友 ${t.name}`} className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="w-full lg:w-3/5 flex flex-col justify-center">
            <span className="text-xs font-medium text-secondary-500 uppercase tracking-widest font-label mb-3">（吃瓜群众说）</span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-8">真实用户<br /><span className="text-foreground-300">口碑评价</span></h2>
            <blockquote className="text-base md:text-lg text-foreground-600 leading-relaxed mb-6 italic">&ldquo;{t.quote}&rdquo;</blockquote>
            <p className="text-sm font-bold text-foreground-950 font-heading">— {t.name}</p>
            <div className="flex items-center gap-3 mt-8">
              <button onClick={goPrev} className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-500 hover:text-foreground-950 hover:border-foreground-400 transition-colors duration-200 cursor-pointer"><i className="ri-arrow-left-line"></i></button>
              <button onClick={goNext} className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors duration-200 cursor-pointer"><i className="ri-arrow-right-line"></i></button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}